import React, { Suspense } from "react";
import "./firebase";
import Spinner from "./components/common/Spinner";
import { HelmetProvider } from "react-helmet-async";
import PageMeta from "./components/PageMeta";
import SeoHelmet from "./components/seoHelmet";
import { Navigate, Route, Routes } from "react-router-dom";
import routes from "./router";
import { BrowserRouter, useLocation } from "react-router-dom";
// import ScrollToTop from "react-scroll-to-top";
import Notice from "./components/notice/AntiFraudNotice";
import ImportantNewsPopup from "@/components/notice/ImportantNews";

// import 'rsuite/dist/rsuite-no-reset.min.css';
import FirebaseStayLoan from "./firebase/stay/stayLoan";
import FirebaseStayStudent from "./firebase/stay/stayLoanStudent";
import FirebaseStayPhone from "./firebase/stay/stayLoanPhone";
import FirebaseStayLaborInsurance from "./firebase/stay/stayLoanLaborInsurance";
import FirebaseStayLaborRelief from "./firebase/stay/stayLoanLaborRelief";
import FirebaseStayPolicy from "./firebase/stay/stayLoanPolicy";
import FirebaseStayMortgage from "./firebase/stay/stayLoanMortgage";
import FirebaseStayAuto from "./firebase/stay/stayLoanAuto";
import FirebaseStayTwoWheel from "./firebase/stay/stayLoanTwoWheel";
import FirebaseStayUsedAuto from "./firebase/stay/stayLoanUsedAuto";
import FirebaseStayBizLease from "./firebase/stay/stayRentBizLease";
import FirebaseStayAboutUs from "./firebase/stay/stayAboutUs";
import FirebaseStayIntro from "./firebase/stay/stayIntro";
import "./App.css";
import "rsuite/styles/index.less";

function App() {
  // const location = useLocation();
  return (
    <HelmetProvider>
      <BrowserRouter>
        <Suspense
          fallback={
            <div className="w-screen h-screen">
              <Spinner />
            </div>
          }
        >
          <div className="App">
            <PageMeta />
            <SeoHelmet />
            <FirebaseStayLoan />
            <FirebaseStayStudent />
            <FirebaseStayPhone />
            <FirebaseStayLaborInsurance />
            <FirebaseStayLaborRelief />
            <FirebaseStayPolicy />
            <FirebaseStayMortgage />
            <FirebaseStayAuto />
            <FirebaseStayTwoWheel />
            <FirebaseStayUsedAuto />
            <FirebaseStayBizLease />
            <FirebaseStayAboutUs />
            <FirebaseStayIntro />
            <ImportantNewsPopup />

            <Notice />
            <Routes>
              {routes.map((route, index) => {
                const RouteComponent = route.component;
                return (
                  <Route
                    key={index}
                    path={route.path}
                    element={
                      <>
                        {/* <ScrollToTop
                          smooth
                          component={
                            <img
                              className=""
                              alt="Arrow upward alt"
                              src="/assets/images/scrollup.svg"
                            />
                          }
                          style={{
                            backgroundColor: "unset",
                            borderRadius: "100%",
                            right: 20,
                            bottom: 84,
                            width: 48,
                            height: 48,
                            boxShadow: "unset",
                            zIndex: 20,
                          }}
                          className="hidden sm:block"
                        /> */}
                        {RouteComponent ? <RouteComponent /> : route.element}
                      </>
                    }
                  />
                );
              })}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </Suspense>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
